import { ref } from 'vue';

type UseAttachmentsOptions = {
  /** Maximum number of files the flow accepts. */
  max?: number;
};

/**
 * File attachments for a request flow. The cap is enforced on both setters:
 * `addAttachments` is the path the file input actually uses, so a cap only on
 * `addAttachment` would never fire.
 */
export function useAttachments({ max = 10 }: UseAttachmentsOptions = {}) {
  const attachments = ref<File[]>([]);

  function addAttachment(file: File) {
    if (attachments.value.length >= max) return;
    attachments.value.push(file);
  }

  function addAttachments(files: File[]) {
    attachments.value = files.slice(0, max);
  }

  function removeAttachment(index: number) {
    attachments.value.splice(index, 1);
  }

  function clearAttachments() {
    attachments.value = [];
  }

  return { attachments, addAttachment, addAttachments, removeAttachment, clearAttachments };
}
